// Camada de apresentação dos rótulos: reexporta a humanização (fonte única em
// @brasilnovo/shared) e traduz o "tone" semântico de severidade em classes
// Tailwind — o acoplamento com CSS fica só no web.
import { severityMeta, type SeverityTone } from "@brasilnovo/shared";

export { humanizeField, kindLabel, kindMeta, INCONSISTENCY_KIND_META, roleLabel, severityMeta, inconsistencyDetail } from "@brasilnovo/shared";
export type { SeverityMeta, SeverityTone, InconsistencyKindMeta } from "@brasilnovo/shared";

const TONE_CLASS: Record<SeverityTone, string> = {
  danger: "bg-red-100 text-red-700",
  warning: "bg-amber-100 text-amber-700",
  info: "bg-blue-100 text-blue-700",
  neutral: "bg-slate-100 text-slate-600",
};

/** Classes Tailwind do badge para uma severidade. */
export const severityClass = (s: string): string => TONE_CLASS[severityMeta(s).tone];
